module.exports = __webpack_public_path__ + "img/logo.ce22b96f.png";